// src/Redux/thunks/bmiHistoryThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosMedical } from "../../../api/axios";
import ENDPOINTS from "../../../api/endpoints";
import { resolveMedicalScope } from "./medicalScope";

/** GET — liste complète de l'historique BMI d'un user */
export const fetchBmiHistoryByUserId = createAsyncThunk(
  "bmiHistory/fetchByUserId",
  async (target, { rejectWithValue, getState }) => {
    try {
      const { userId, headers } = resolveMedicalScope(getState(), target);
      const { data } = await axiosMedical.get(
        ENDPOINTS.MEDICAL.BMI_HISTORY(userId),
        { headers }
      );
      if (!Array.isArray(data)) {
        return rejectWithValue("Format inattendu: un tableau est attendu");
      }
      return data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message ||
          err?.message ||
          "Erreur lors de la récupération de l’historique BMI"
      );
    }
  }
);

/** POST — ajouter une mesure BMI */
export const addBmiEntry = createAsyncThunk(
  "bmiHistory/addEntry",
  async ({ userId, values }, { rejectWithValue }) => {
    try {
      // values: { poidsKg, tailleCm, (optionnel) date }
      const { data } = await axiosMedical.post(
        ENDPOINTS.MEDICAL.BMI_HISTORY(userId),
        values,
        { headers: { "Content-Type": "application/json" } }
      );
      return data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message ||
          err?.message ||
          "Erreur lors de l’ajout de la mesure BMI"
      );
    }
  }
);

/** PUT — mettre à jour une mesure BMI par id */
export const updateBmiEntry = createAsyncThunk(
  "bmiHistory/updateEntry",
  async ({ userId, id, values }, { rejectWithValue }) => {
    try {
      // values: { poidsKg?, tailleCm?, date? }
      const { data } = await axiosMedical.put(
        ENDPOINTS.MEDICAL.UPDATE_BMI_HISTORY(userId, id),
        values,
        { headers: { "Content-Type": "application/json" } }
      );
      return data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message ||
          err?.message ||
          "Erreur lors de la mise à jour de la mesure BMI"
      );
    }
  }
);
